var map = {
	"./check.svg": 4919,
	"./chevron-down.svg": 44443,
	"./chevron-up.svg": 49940,
	"./circle-pause.svg": 25964,
	"./close.svg": 9771,
	"./conference.svg": 72399,
	"./emotion.svg": 95392,
	"./keyboard.svg": 7854,
	"./logout.svg": 4583,
	"./map.svg": 71321,
	"./menu.svg": 30524,
	"./microphone-slash.svg": 15037,
	"./microphone.svg": 58305,
	"./pause.svg": 97825,
	"./pencil.svg": 62054,
	"./phone-hangup.svg": 1059,
	"./phone-hangup11.svg": 17465,
	"./phone-setting.svg": 744,
	"./phone-status.svg": 26914,
	"./phone-transfer-bk.svg": 4655,
	"./phone-transfer-wait.svg": 17433,
	"./phone-transfer.svg": 69549,
	"./phone-transfer2.svg": 41733,
	"./phone.svg": 16627,
	"./play-circle.svg": 63256,
	"./play.svg": 82587,
	"./search.svg": 76433,
	"./settings.svg": 42258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66519;